
import { defineComponent, PropType } from 'vue'
import { useOrderModel } from '@entities/order'
import { useCustomLogicModel } from '@shared/model'
import { ButtonClose } from '@shared/ui'
interface IData {
  promoCode: string
}
export default defineComponent({
  components: { ButtonClose },
  props: {
    error: {
      type: String as PropType<string>,
      required: false,
      default: ''
    },
    waitingAcceptPromocode: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false
    },
    acceptingPromocode: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false
    },
    separateOrderAlienGuest: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false
    }
  },

  emits: ['applyPromoCode', 'clearError'],

  setup () {
    const customLogicModel = useCustomLogicModel()
    const orderModel = useOrderModel()

    return {
      customLogicModel,
      orderModel
    }
  },

  data (): IData {
    return {
      promoCode: ''
    }
  },

  async mounted () {
    if (this.customLogicModel.list.promocode) {
      const savedPromocode = await this.$cookies.get('promocode')
      const savingOrderId = await this.$cookies.get('order_id')

      if (savedPromocode && this.orderModel.orderData && savingOrderId === this.orderModel.orderData.orders[0].order_id && this.orderModel.orderData.discountStatus !== 'EMPTY') {
        this.promoCode = savedPromocode
      }
    }
  },

  methods: {
    clearPromoCode (): void {
      this.promoCode = ''
      this.$emit('clearError')
    },

    sendPromoCode (): void {
      this.$emit('clearError')
      this.$emit('applyPromoCode', this.promoCode)
    }
  }
})
